import { Injectable } from '@angular/core';
import { UserService } from '../../../services/core.user.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import * as _ from 'lodash';
import { StateService } from '@uirouter/angular';
import { marker } from '../../../services/ngx-translate-extract-marker';

@Injectable()
export class UserHeaderService {
  private menuData: any[];

  private unixName: string;

  constructor(
    private translateService: GfTranslateService,
    private userService: UserService,
    private stateService: StateService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.unixName = this.userService.session.getUnixName();

    this.menuData = [
      this.createMenuItem(marker('Home'), 'home.user.userhome', 'glyph-img-user'),
      this.createMenuItem(marker('To-Do'), 'home.user.my', 'glyph-img-ticket'),
      this.menuSeparator(),
      this.createMenuItem(marker('Notifications'), 'home.user.notifications', 'glyph-img-notification'),
      this.createMenuItem(marker('My Reports'), 'home.user.myreports', 'glyph-img-report'),
      this.createMenuItem(marker('Notebook'), 'home.user.notebook', 'glyph-img-wiki'),
      this.getSiteSupportMenuItem(),
      this.menuSeparator(),
      this.createMenuItem(marker('Edit Profile'), 'home.user.edit', 'glyph-img-wiki'),
      this.createMenuItem(marker('SSH Keys'), 'home.user.ssh', 'glyphicon glyphicon-console'),
      this.createMenuItem(marker('Change Password'), 'home.user.changepassword', 'glyphicon glyphicon-text-color'),
    ].filter((item) => item != null);
  }

  private menuSeparator() {
    return {};
};

  private getMenuItemForState(stateName: string): any {
    return _.find(this.menuData, (m) => m.state == stateName);
  }

  getMenuData(): any[] {
    return this.menuData;
  }

  getTitleForState(stateName: string): string {
    return _.get(this.getMenuItemForState(stateName), 'title', this.unixName);
  }

  getGlyphForState(stateName: string): string {
    return _.get(this.getMenuItemForState(stateName), 'glyph', 'glyph-img-user');
  }

  createMenuItem(title: string, stateName: string, glyphClasses: string): any {
    const stateParams = { unixName: this.unixName };
    return {
      title: this.translateService.translate(title),
      state: stateName,
      stateParams: stateParams,
      glyph: glyphClasses,
    };
  }

  getSiteSupportMenuItem(): any {
    const feedbackTracker = _.get(this.document.defaultView, 'feedbackTracker');
    if (feedbackTracker) {
        if (feedbackTracker) {
        return {
            title: this.translateService.translate('My Site Support Tickets'),
            state: 'home.tracker',
            stateParams: { id: feedbackTracker },
            glyph: 'glyph-img-ticket',
        };
        }
        return null;
    }
  }
}
